import script from "./BalTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./BalTooltip.vue?vue&type=style&index=0&id=b2bc8c86&lang=css"

const __exports__ = script;

export default __exports__